<section class="user-profile-lessons-subpage profile-section"
         [class.mobile]="deviceService.isMobile()"
         [class.tablet]="deviceService.isTablet()" rel="lessons">
  <app-title [title]="'user-profile.tab-lessons'"></app-title>

  <div class="lessons-block" *ngIf="teachingSubjectsList?.length">
    <app-pane [item]="paneLessons" (loadFinished)="checkContent($event)"></app-pane>
  </div>

    <ng-template [ngIf]="!isContent">
      <app-empty *ngIf="isMe" [empty]="emptyLessonObj"></app-empty>
    </ng-template>
</section>
